import { motion } from 'framer-motion';

const cards = [
  { key: 'totalPosts', label: 'Total Posts', color: 'text-white' },
  { key: 'published', label: 'Published', color: 'text-green-400' },
  { key: 'drafts', label: 'Drafts', color: 'text-yellow-400' },
  { key: 'totalViews', label: 'Total Views', color: 'text-neon-cyan' },
  { key: 'contacts', label: 'Contacts', color: 'text-neon-purple' },
];

export function StatsBar({ stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
      {cards.map((card, i) => (
        <motion.div
          key={card.key}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.1 }}
          className="glass rounded-xl p-4"
          data-testid={`stat-${card.key}`}
        >
          <p className="text-white/50 text-sm">{card.label}</p>
          <p className={`text-2xl font-heading font-bold ${card.color}`}>
            {stats[card.key] ?? 0}
          </p>
        </motion.div>
      ))}
    </div>
  );
}

export default StatsBar;
